import { useQueries, useQuery } from '@tanstack/react-query'
import { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'

import { explorarFuente, obtenerFuentes } from '../api/consultas'
import Portada from '../componentes/Portada'

// Las fuentes de MangaDex existen en decenas de idiomas; sin este filtro la
// busqueda global lanzaria ochenta peticiones y tardaria un minuto.
const IDIOMAS = ['es', 'es-419', 'en', 'all']

export default function Buscar() {
  const [texto, setTexto] = useState('')
  const [consulta, setConsulta] = useState('')

  const { data: fuentes } = useQuery({ queryKey: ['fuentes'], queryFn: obtenerFuentes })

  const candidatas = useMemo(
    () => (fuentes ?? []).filter((f) => IDIOMAS.includes(f.lang) && f.name !== 'Local source'),
    [fuentes],
  )

  const resultados = useQueries({
    queries: candidatas.map((fuente) => ({
      queryKey: ['buscar', fuente.id, consulta],
      queryFn: () => explorarFuente(fuente.id, 'SEARCH' as const, 1, consulta),
      enabled: consulta.length > 1,
      retry: false,
      staleTime: 10 * 60 * 1000,
    })),
  })

  const terminadas = resultados.filter((r) => !r.isFetching).length
  const buscando = consulta.length > 1 && terminadas < candidatas.length

  return (
    <>
      <h1>Buscar</h1>
      <p className="subtitulo">En todas tus fuentes a la vez</p>

      <form
        className="fila-busqueda"
        onSubmit={(e) => {
          e.preventDefault()
          setConsulta(texto.trim())
        }}
      >
        <input
          type="text"
          placeholder="Titulo del manga…"
          value={texto}
          onChange={(e) => setTexto(e.target.value)}
        />
        <button className="boton" type="submit">
          Buscar
        </button>
      </form>

      {buscando && (
        <p className="cargando">
          Buscando… {terminadas} de {candidatas.length} fuentes
        </p>
      )}

      {consulta.length > 1 &&
        candidatas.map((fuente, i) => {
          const resultado = resultados[i]
          // Las fuentes caidas se omiten en silencio: en una busqueda global
          // no aporta nada llenar la pantalla de errores de sitios ajenos.
          if (!resultado || resultado.isFetching || resultado.error) return null
          const mangas = resultado.data?.mangas ?? []
          if (mangas.length === 0) return null

          return (
            <section key={fuente.id}>
              <h2 className="titulo-seccion">
                {fuente.name}
                <span className="etiqueta-idioma">{fuente.lang}</span>
              </h2>
              <div className="carrusel">
                {mangas.slice(0, 12).map((manga) => (
                  <Link key={manga.id} to={`/manga/${manga.id}`} className="tarjeta carrusel-item">
                    <Portada ruta={manga.thumbnailUrl} titulo={manga.title} />
                    <div className="titulo-tarjeta">{manga.title}</div>
                  </Link>
                ))}
              </div>
            </section>
          )
        })}

      {consulta.length > 1 && !buscando && resultados.every((r) => !r.data?.mangas.length) && (
        <div className="aviso">
          <strong>Sin resultados para «{consulta}»</strong>
          <p style={{ fontSize: 13 }}>
            Prueba con el titulo original en japones romanizado, o en ingles. Muchas fuentes no
            indexan el titulo traducido.
          </p>
        </div>
      )}
    </>
  )
}
